import React from 'react';
import {withJsonFormsControlProps} from '@jsonforms/react';
import {Counter} from '@/components/atoms';
import PropTypes from 'prop-types';

const CounterComponent = (props) => {
  const {handleChange, label, data, path, errors, uischema, required, enabled} =
    props;

  const onUpdate = (newVal) => {
    handleChange(path, newVal);
  };

  return (
    <Counter
      value={data ?? ''}
      onUpdate={onUpdate}
      disabled={!enabled}
      label={uischema.showLabel === false ? '' : label}
      minValue={uischema.minValue}
      maxValue={uischema.maxValue}
      placeholder={uischema.placeholder}
      feedbackType={errors ? 'error' : undefined}
      helperText={errors}
      isDark={uischema.isDark}
      className={uischema.className}
      style={uischema.style}
      required={required}
    />
  );
};

CounterComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  path: PropTypes.string.isRequired,
  errors: PropTypes.string,
  uischema: PropTypes.object,
  required: PropTypes.bool,
  enabled: PropTypes.bool
};

const CounterControl = withJsonFormsControlProps(CounterComponent);
export default React.memo(CounterControl);
